import $axios from "../api/accessor";
import { $api } from "../api/api";

export const BannerService = {
  // Get Banner Image
  async getBannerImage() {
    const response = await $axios.get($api("banners")).catch((err) => {
      return err.response;
    });

    return {
      data: response?.data ? response?.data.data : [],
      status: response?.status,
    };
  },

  // Added Banner Image
  async addedBannerImage(payload: { image: string }) {
    const response = await $axios
      .post($api("banners"), payload)
      .catch((err) => err.response);

    return {
      data: response?.data ? response?.data.data : [],
      status: response?.status,
    };
  },

  // Update Banner Image
  async updateBannerImage(id: number, payload: { image: string }) {
    const response = await $axios
      .put($api("banners_id", { id }), payload)
      .catch((err) => err.response);

    return {
      data: response?.data ? response?.data.data : [],
      status: response?.status,
    };
  },

  // Delete Banner Image
  async deleteBannerImage(id: number) {
    const response = await $axios
      .delete($api("banners_id", { id }))
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data.data : [],
      status: response?.status,
    };
  },
};
